export default "__VITE_ASSET__C27_S1ew__"